import { render, staticRenderFns } from "./validationSummary.vue?vue&type=template&id=be4b5d2c&scoped=true"
import script from "./validationSummary.vue?vue&type=script&lang=js"
export * from "./validationSummary.vue?vue&type=script&lang=js"
import style0 from "./validationSummary.vue?vue&type=style&index=0&id=be4b5d2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4b5d2c",
  null
  
)

export default component.exports